import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VoiceChatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"voice_chat"}/>
}
